export default function FootLengthRuler({ t, value, onChange, min = 16, max = 32, step = 0.5 }) {
  const num = parseFloat(value) || min;

  return (
    <div className="mt-4 pt-4 border-t border-slate-700/50">
      <p className="text-xs text-slate-500 mb-3">{t.footRuler.label}</p>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={num}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-2 rounded-lg appearance-none bg-slate-700 accent-emerald-500 cursor-pointer"
      />
      <div className="flex justify-between mt-2 text-[10px] text-slate-600 font-mono">
        <span>{min} cm</span>
        <span className="text-emerald-400 font-semibold text-sm">{num} cm</span>
        <span>{max} cm</span>
      </div>
      <div className="mt-2 h-2 rounded-full bg-gradient-to-r from-slate-700 via-emerald-900/50 to-slate-700 overflow-hidden">
        <div
          className="h-full bg-emerald-500/60 transition-all"
          style={{ width: `${((num - min) / (max - min)) * 100}%` }}
        />
      </div>
    </div>
  );
}
